// Brands
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faAward as farAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { faCamera as farCamera } from '@fortawesome/pro-regular-svg-icons/faCamera';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faDumbbell as farDumbbell } from '@fortawesome/pro-regular-svg-icons/faDumbbell';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHotel as farHotel } from '@fortawesome/pro-regular-svg-icons/faHotel';
import { faList as farList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faMapMarkedAlt as farMapMarkedAlt } from '@fortawesome/pro-regular-svg-icons/faMapMarkedAlt';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faPlaneArrival as farPlaneArrival } from '@fortawesome/pro-regular-svg-icons/faPlaneArrival';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faRoad as farRoad } from '@fortawesome/pro-regular-svg-icons/faRoad';
import { faSearchPlus as farSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faThList as farThList } from '@fortawesome/pro-regular-svg-icons/faThList';
import { faTrophy as farTrophy } from '@fortawesome/pro-regular-svg-icons/faTrophy';

// Solid
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faInfoCircle as fasInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faFilePdf as fasFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';

const exports = {
  fabFacebook,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTumblr,
  fabTwitter,
  fabYoutube,
  farAt,
  farAward,
  farCamera,
  farClock,
  farDumbbell,
  farDownload,
  farEnvelope,
  farHandshake,
  farHotel,
  farList,
  farMapMarkedAlt,
  farPrint,
  farPlaneArrival,
  farRoad,
  farStroopwafel,
  farHeart,
  farSearchPlus,
  farSearch,
  farCheckCircle,
  farFileCertificate,
  farThList,
  farTrophy,
  fasAt,
  fasAngleLeft,
  fasAngleRight,
  fasBars,
  fasBookReader,
  fasBug,
  fasBullhorn,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasCheck,
  fasCheckCircle,
  fasChevronLeft,
  fasChevronRight,
  fasInfoCircle,
  fasCircle,
  fasCircleNotch,
  fasClock,
  fasDownload,
  fasEnvelope,
  fasFax,
  fasGraduationCap,
  fasHandshake,
  fasHeart,
  fasHome,
  fasImages,
  fasFilePdf,
  fasKey,
  fasLink,
  fasList,
  fasLock,
  fasMap,
  fasPhone,
  fasPrint,
  fasSearch,
  fasSearchPlus,
  fasShieldAlt,
  fasSignOutAlt,
  fasStroopwafel,
  fasThList,
  fasTimes,
  fasUser,
  fasWindowClose,
};

export default exports;
